<template functional>
  <div
    :class="data.staticClass"
    :style="{ borderRadius: props.radius ? `${props.radius}px` : 'auto' }"
    class="card"
    v-bind="{...data.attrs, [parent.$options._scopeId]: ''}"
    v-on="listeners"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    radius: Number,
  },
}
</script>

<style scoped lang="scss">
.card {
  overflow: hidden;
  border-radius: $round;
  background: $white;
  box-shadow: $card-shadow;
}
</style>
